<template>
  <div id="home">
    <div class="bg-grid">
      <div class="faixa-container faixa-banner">
        <img
          id="img-faixa-inscrevase"
          src="@/assets/img/2023/banner-inscrevase.png"
          alt="Inscreva suas peças"
        />
      </div>
      <section id="section-banner" class="container">
        <img
          id="img-banner-titulo"
          src="@/assets/img/2023/banner-titulo.png"
          alt="Criatividade é o que impulsiona"
        />
        <img
          id="img-banner-txt"
          src="@/assets/img/2023/banner-txt.png"
          alt="O futuro da publicidade só é incerto pra quem parou no tempo."
        />
        <h1>
          <img
            id="img-midia-festival-logo"
            src="@/assets/img/2023/banner-logo-midia-festival.png"
            alt="Mídia Festival"
          />
        </h1>
      </section>
    </div>
    <div class="bg-pink">
      <section id="section-festival" class="container">
        <img
          id="img-festival-premio"
          src="@/assets/img/2023/festival-premio.png"
          alt="Prêmio"
        />
        <div id="festival-content">
          <h2 id="festival-titulo">O FESTIVAL</h2>
          <p id="text-festival">
            <img
              id="festival-circulos"
              src="@/assets/img/2023/festival-circulos.png"
              alt=""
            />
            Do layout lascado ao gerador de imagens, a grande ideia continua
            sendo o mais importante na hora de inovar. Vem aí o 33º Mídia
            Festival, um evento tradicional na região que premia os
            profissionais que chegam a soluções
            <span id="text-incriveis">incríveis</span>, independentemente da
            ferramenta que usam.
          </p>
        </div>
      </section>

      <div class="faixa-container faixa-festival">
        <img
          id="img-faixa-inscrevase-festival"
          src="@/assets/img/2023/festival-faixa-inscrevase.png"
          alt=""
        />
      </div>
    </div>
    <section id="section-regulamento" class="bg-grid">
      <img
        id="bg-regulamento"
        src="@/assets/img/2023/regulamento-background-cut.png"
        alt=""
      />
      <div class="container">
        <div id="container-regulamento">
          <h2 id="regulamento-title-container" class="font-arame-mono-bold">
            Regulamento
          </h2>
          <div class="regulamento-btn-container">
            <a
              target="_blank"
              href="/regulamentos/2023/regulamento-pecas-publicitarias-2023.pdf"
              class="btn-regulamento font-arame-mono"
            >
              <span>Peça Publicitária</span>
            </a>
            <a
              target="_blank"
              href="/regulamentos/2023/regulamento-estudantes-2023.pdf"
              class="btn-regulamento font-arame-mono"
            >
              <span>Estudante</span>
            </a>
            <a
              target="_blank"
              href="/regulamentos/2023/regulamento-fornecedores-2023.pdf"
              class="btn-regulamento font-arame-mono"
            >
              <span>Fornecedor</span>
            </a>
          </div>
          <div class="regulamento-btn-container">
            <router-link to="/cadastro" class="btn-round inscreva-se">
              <span>Inscreva-se</span>
            </router-link>
          </div>
        </div>
      </div>
    </section>

    <section id="section-datas" class="bg-grid">
      <img id="datas-square" src="@/assets/img/2023/datas-squares.png" alt="" />
      <img id="bg-datas" src="@/assets/img/2023/datas-background.png" alt="" />
      <div id="datas-container" class="container">
        <div>
          <h2 id="datas-title-container" class="font-arame-mono-bold">Datas</h2>
          <div class="data-single-container">
            <div class="txt-data-title">18/09</div>
            <div class="txt-data-subtitle">Início das inscrições</div>
          </div>
          <div class="data-single-container">
            <div class="txt-data-title">09/11</div>
            <div class="txt-data-subtitle">Término das inscrições</div>
          </div>
          <div class="data-single-container">
            <div class="txt-data-title">22/11</div>
            <div class="txt-data-subtitle">Shortlist</div>
          </div>
          <div class="data-single-container">
            <div class="txt-data-title">28/11</div>
            <div class="txt-data-subtitle">Cerimônia de premiação</div>
          </div>
        </div>
        <div id="datas-subtitle" class="font-arame-mono-thin">
          <img src="@/assets/img/2023/datas-globe.png" />
          <p id="datas-subtitle-text">
            33º edição Mídia Festival Criatividade é o que impulsiona
          </p>
          <img id="datas-line" src="@/assets/img/2023/datas-line.png" />
        </div>
      </div>
      <div class="faixa-container faixa-datas">
        <img
          id="img-faixa-inscrevase-datas"
          src="@/assets/img/2023/banner-inscrevase.png"
          alt="Inscreva suas peças"
        />
      </div>
    </section>
    <section id="section-patrocinadores">
      <div class="container-fluid py-6">
        <div id="patrocinadores-wrapper" class="container">
          <div class="d-flex justify-content-center">
            <h2 class="text-uppercase font-arame-mono patrocinadores-title">
              Patrocinadores
            </h2>
          </div>
          <b-row class="mt-2 justify-content-between">
            <b-col cols="5">
              <h3
                class="font-arame-mono text-uppercase mb-3 text-center text-xl-left patrocinadores-title"
              >
                Mantenedores Ouro:
              </h3>
              <div
                class="mantenedores-ouro-wrapper w-100 d-flex flex-wrap justify-content-center justify-content-xl-start"
              >
                <img
                  src="@/assets/img/patrocinadores/mantenedores-ouro/band-mais.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-ouro/tv-thati-record-new.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-ouro/eptv-g1.png"
                />
              </div>
            </b-col>
            <b-col cols="6">
              <h3
                class="font-arame-mono text-uppercase mb-3 mt-sm-4 mt-lg-0 text-center text-xl-left patrocinadores-title"
              >
                Mantenedores Prata:
              </h3>
              <div
                class="mantenedores-prata-wrapper w-100 d-flex flex-wrap justify-content-center justify-content-xl-start"
              >
                <img
                  src="@/assets/img/patrocinadores/mantenedores-prata/clear-channel.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-prata/eletromidia.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-prata/jcdecaux.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-prata/jovem-pan-campinas.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-prata/rede-familia-2022.png"
                />
                <img src="@/assets/img/patrocinadores/comunicacao/ciclo.png" />
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col lg="6">
              <h3
                class="font-arame-mono patrocinadores-title text-uppercase mb-3 text-center"
              >
                Patrocinador Bronze:
              </h3>
              <div
                class="apoio-wrapper d-flex justify-content-center flex-wrap"
              >
                <img
                  src="@/assets/img/patrocinadores/mantenedores-bronze/extreme-reach.png"
                />
              </div>
            </b-col>
            <b-col lg="6">
              <h3
                class="font-arame-mono patrocinadores-title text-uppercase mb-3 text-center text-lg-left"
              >
                Comunicação:
              </h3>
              <div
                class="apoio-wrapper d-flex justify-content-center justify-content-lg-start flex-wrap"
              >
                <img
                  class="arpejo-logo"
                  src="@/assets/img/patrocinadores/comunicacao/arpejo.png"
                />
                <img src="@/assets/img/patrocinadores/comunicacao/ciclo.png" />
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </section>
    <section id="footer">
      <div
        id="footer-wrapper"
        class="container-fluid bg-gray-dark position-relative"
      >
        <div class="container py-5">
          <b-row>
            <b-col sm="6" lg="4">
              <img
                id="logo-app"
                class="d-flex justify-content-end align-items-center"
                src="@/assets/img/2021/logo-app.png"
              />
            </b-col>
            <b-col
              sm="6"
              md="4"
              lg="6"
              class="d-flex justify-content-start align-items-center"
            >
              <p id="text-address" class="text-white mb-0">
                Telefone: (19) 3255-1081
              </p>
            </b-col>
            <b-col
              md="2"
              lg="2"
              class="d-flex justify-content-center align-items-center justify-content-md-end"
            >
              <a href="https://www.facebook.com/appcampinas" target="_blank"
                ><img
                  class="social-media-logo"
                  src="@/assets/img/2021/facebook-logo.png"
              /></a>
              <a href="https://www.instagram.com/appcampinas" target="_blank"
                ><img
                  class="social-media-logo"
                  src="@/assets/img/2021/instagram-logo.png"
              /></a>
            </b-col>
          </b-row>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  methods: {
    scrollToElement(refName) {
      document.getElementById(refName).scrollIntoView({
        behavior: "smooth",
      });
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scope>
@import "node_modules/bootstrap/scss/functions";
@import "node_modules/bootstrap/scss/variables";
@import "node_modules/bootstrap/scss/mixins/_breakpoints";

@include media-breakpoint-down(xs) {
  html {
    font-size: 12px;
  }
}

html {
  //overflow-x: hidden;
}

// CSSTOP

.bg-grid {
  background: black url("~@/assets/img/2023/banner-grid-mini.png") repeat center
    center fixed;
}

.bg-pink {
  background-color: #ca1b94 !important;
}

#img-banner-titulo {
  max-width: 100%;
  margin-bottom: 27%;
}

#img-banner-txt {
  right: 2%;
  position: absolute;
  max-width: 45%;
  bottom: 17.5%;
}

#img-midia-festival-logo {
  position: absolute;
  bottom: 15%;
  left: 3%;
  max-width: 20%;
}

#img-festival-premio {
  margin-top: -179px;
  max-width: 44%;
  position: relative;
  height: auto;
  align-self: center;

  @include media-breakpoint-down(lg) {
    margin-top: 0;
  }

  @include media-breakpoint-down(sm) {
    margin-top: 0;
  }
}

@font-face {
  font-family: "ArameMono";
  src: url("~@/assets/fonts/ArameMono.ttf");
}

@font-face {
  font-family: "ArameMonoBold";
  src: url("~@/assets/fonts/ArameMono-Bold.ttf");
}

@font-face {
  font-family: "ArameMonoThin";
  src: url("~@/assets/fonts/ArameMono-Thin.ttf");
}

.font-arame-mono {
  font-family: ArameMono;
}

.font-arame-mono-bold {
  font-family: ArameMonoBold;
}

.font-arame-mono-thin {
  font-family: ArameMonoThin;
}

#home {
  background-color: #000000;
}

/* MAIN BANNER */

.faixa-container {
  width: 100%;
  overflow: hidden;

  & img {
    min-width: 100%;
    @include media-breakpoint-down(lg) {
      height: 28px;
    }
    @include media-breakpoint-down(md) {
      height: 24px;
    }
    @include media-breakpoint-down(sm) {
      height: 20px;
    }
  }
  &.faixa-banner {
    padding: 20px 0 0;

    @include media-breakpoint-down(sm) {
      padding: 5px 0 0;
    }
  }

  &.faixa-festival {
    padding: 0 0 20px;
    @include media-breakpoint-down(xs) {
      padding: 0 0 15px;
    }
  }

  &.faixa-datas {
    padding: 20px 0 20px;
    z-index: 5;
    position: absolute;
    bottom: 0;

    @include media-breakpoint-down(xs) {
      padding: 10px 0 10px;
    }
  }
}

#section-banner {
  position: relative;
  padding-top: 100px;

  @include media-breakpoint-down(lg) {
    padding-top: 70px;
  }

  @include media-breakpoint-down(md) {
    padding-top: 50px;
  }

  @include media-breakpoint-down(sm) {
    padding-top: 30px;
  }

  @include media-breakpoint-down(xs) {
    padding-top: 15px;
  }
}

/* O FESTIVAL */
#section-festival {
  position: relative;
  margin-bottom: 50px;
  display: flex;
  justify-content: flex-start;
}

#festival-content {
  flex-grow: 1;
  display: flex;
}

#festival-titulo {
  font-family: "ArameMono";
  color: #ffffff;
  writing-mode: tb-rl;
  transform: rotate(-180deg);
  margin: 0 0 0 40px;
  font-size: 94px;
  height: 600px;

  @include media-breakpoint-down(md) {
    font-size: 60px;
    margin-left: 0;
    height: 450px;
  }

  @include media-breakpoint-down(xs) {
    font-size: 35px;
    margin-left: 0;
    height: 280px;
  }
}

#text-festival {
  display: block;
  font-size: 1.8rem;
  font-family: "ArameMono";
  color: #000000;
  margin-top: 20px;
  margin: 20px 0 0 0;
  font-size: 1.7rem;
  text-align: justify;
  line-height: 1.2em;
  width: 340px;

  @include media-breakpoint-down(lg) {
    width: 70%;
    font-size: 1.7rem;
  }

  @include media-breakpoint-down(md) {
    width: 70%;
    font-size: 1.2rem;
  }

  @include media-breakpoint-down(xs) {
    width: 70%;
    font-size: 0.9rem;
  }
}

#text-incriveis {
  letter-spacing: 0.7em;

  @include media-breakpoint-down(md) {
    letter-spacing: 0.5em;
  }
}

#festival-circulos {
  width: 100%;
  margin-bottom: 40px;
}

/* REGULAMENTO */
#bg-regulamento {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;

  @include media-breakpoint-down(lg) {
    margin-right: -100px;
  }
  @include media-breakpoint-down(md) {
    margin-right: -280px;
  }
  @include media-breakpoint-down(sm) {
    margin-right: -380px;
  }
  @include media-breakpoint-down(xs) {
    margin-right: -500px;
  }
}

#section-regulamento {
  position: relative;
  padding: 80px 0 110px;
  overflow: hidden;

  @include media-breakpoint-down(md) {
    padding-bottom: 50px;
  }
}

#img-regulamento-bg {
  width: 100%;
  position: absolute;
}

#container-regulamento {
  max-width: 80%;
}

#regulamento-title-container {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
  font-size: 7rem;
  letter-spacing: 0em;
  color: #ca1b94;
  font-weight: normal;

  @include media-breakpoint-down(lg) {
    font-size: 5rem;
  }
  @include media-breakpoint-down(md) {
    font-size: 4rem;
  }
  @include media-breakpoint-down(sm) {
    font-size: 3rem;
  }
}

.regulamento-btn-container {
  display: flex;
  justify-content: center;
  width: 100%;

  @include media-breakpoint-down(md) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.btn-regulamento {
  color: #cccccc;
  font-size: 35px;
  margin: 0 20px;
  z-index: 2;
  text-decoration: underline;

  @include media-breakpoint-down(lg) {
    font-size: 25px;
  }

  @include media-breakpoint-down(xs) {
    font-size: 20px;
  }
}

.btn-regulamento:hover {
  color: #ca1b94;
  text-decoration: underline;
}

.regulamento-btn-container .btn-round:first-child {
  margin-left: 0;
}
.regulamento-btn-container .btn-round:last-child {
  margin-right: 0;
}

.btn-round.inscreva-se {
  font-family: ArameMono;
  font-size: 2.3rem;
  margin-top: 80px;
  height: 80px;
  min-width: 450px;
  z-index: 4;

  @include media-breakpoint-down(md) {
    font-size: 2rem;
  }

  @include media-breakpoint-down(sm) {
    min-width: 300px;
    font-size: 1.7rem;
  }

  @include media-breakpoint-down(xs) {
    font-size: 1.4rem;
    font-family: ArameMonoBold;
    width: 70%;
    min-width: 170px;
  }
}

.btn-round {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 2px solid;
  font-family: BrandonRegular;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.4rem;
  height: 70px;
  min-width: 278px;
  text-decoration: none;
  color: #ca1b94;
  white-space: nowrap;
  margin-bottom: 25px;

  @include media-breakpoint-up(lg) {
    margin: 0 4%;
  }
}

.btn-round:hover {
  color: #ca1b94;
  text-decoration: none;
  background: rgba(202, 27, 148, 0.15);
}

/* DATAS */
#section-datas {
  position: relative;
  background-color: #0a0fbc;
  z-index: 3;
  min-height: 1000px;

  @include media-breakpoint-down(lg) {
    min-height: unset;
  }
}

#bg-datas {
  position: absolute;
  right: 0;
  z-index: 4;
  width: 58%;

  @include media-breakpoint-down(md) {
    width: 68%;
  }

  @include media-breakpoint-down(sm) {
    width: 78%;
  }

  @include media-breakpoint-down(xs) {
    width: 88%;
  }
}

#datas-subtitle {
  color: #ffffff;
  display: flex;
  align-items: center;
  margin-top: 80px;
}

#datas-subtitle-text {
  font-size: 1.4rem;
  width: 430px;
  margin: 0 0 0 22px;
}

#datas-line {
  align-self: flex-end;
  margin-bottom: 10px;
  width: 90px;
}

#datas-container {
  position: relative;
  overflow: hidden;
  padding-bottom: 70px;
}

#datas-title-container {
  padding-top: 120px;
  color: #ffffff;
  font-size: 7rem;
  margin-bottom: 24px;
  position: relative;
  z-index: 4;
}

#datas-square {
  position: absolute;
  z-index: 5;
  right: 4%;
  width: 220px;
  top: -50px;

  @include media-breakpoint-down(md) {
    width: 148px;
  }
}

.data-single-container {
  position: relative;

  z-index: 5;
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.txt-data-title {
  font-family: ArameMonoBold;
  font-size: 3.4em;
  color: #ca1b94;
  width: 200px;

  @include media-breakpoint-down(lg) {
    width: unset;
  }

  @include media-breakpoint-down(md) {
    width: unset;
  }
}

.txt-data-subtitle {
  font-family: ArameMonoThin;
  text-transform: uppercase;
  font-size: 2em;
  color: #ffffff;
  z-index: 50;
  margin-left: 10px;

  @include media-breakpoint-down(md) {
    font-size: 1.5em;
  }
}

/* PATROCINADORES */
#section-patrocinadores {
  position: relative;
  z-index: 1;
  background: url("~@/assets/img/2023/patrocinadores-background-cut.png")
    no-repeat;
}

#bg-patrocinadores {
  width: 100%;
  position: absolute;
}

#patrocinadores-wrapper {
  background: url("~@/assets/img/2023/patrocinadores-outdoor-frame-white.png")
    no-repeat;
  background-size: 100% 100%;
  padding: 50px;

  @include media-breakpoint-down(lg) {
    padding-top: 55px;
    padding-bottom: 55px;
  }

  @include media-breakpoint-down(sm) {
    padding-top: 60px;
    padding-bottom: 60px;
  }
}

.patrocinadores-title {
  font-size: 1.3rem;
  color: #ca1b94;
}

h2.patrocinadores-title {
  font-size: 1.8rem;
}

/* FOOTER */

#logo-app {
  width: 300px;

  @include media-breakpoint-down(md) {
    width: 100%;
  }
}

/* REST */
.img-titulo {
  width: 300px;

  @include media-breakpoint-down(md) {
    width: 100%;
    max-width: 300px;
  }
}

.img-titulo-sm {
  width: 130px;
}

#txt-banner-subtitle {
  position: relative;
  font-family: BrandonRegular;
  text-transform: uppercase;
  color: #9d9d9c;
  line-height: 3rem;
  letter-spacing: 0.6rem;
  font-size: 1.6rem;
  margin-bottom: 80px;
  z-index: 1;

  @include media-breakpoint-down(lg) {
    margin-bottom: 120px;
  }

  @include media-breakpoint-down(md) {
    margin-bottom: 620px;
  }

  @include media-breakpoint-down(sm) {
    margin-bottom: 680px;
  }

  @include media-breakpoint-down(xs) {
    margin-bottom: calc(80vw);
  }
}

.img-titulo-md {
  width: 210px;

  @include media-breakpoint-down(md) {
    width: 100%;
    max-width: 210px;
  }
}

.mantenedores-ouro-wrapper img {
  align-self: center;
  max-height: 100px;
  max-width: 240px;
  margin: 10px 30px;

  @include media-breakpoint-down(xs) {
    max-width: 128px;
  }
}

.mantenedores-prata-wrapper img {
  align-self: center;
  max-height: 75px;
  max-width: 123px;
  margin: 10px 20px;
}

.apoio-wrapper {
  & img {
    align-self: center;
    max-height: 60px;
    max-width: 100px;
    margin: 5px 20px;
  }
  & img.arpejo-logo {
    max-width: 75px;
    max-height: 40px;
  }
}

.social-media-logo {
  height: 25px;
  margin-left: 15px;
}

@media (min-width: 1400px) {
  .container {
    max-width: 1340px;
  }
}

#text-address {
  font-size: 0.9rem;
}

img {
  image-rendering: -moz-crisp-edges; /* Firefox        */
  image-rendering: -o-crisp-edges; /* Opera          */
  image-rendering: -webkit-optimize-contrast; /* Safari         */
  image-rendering: optimize-contrast; /* CSS3 Proposed  */
  -ms-interpolation-mode: nearest-neighbor; /* IE8+           */
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}
</style>
